class EqualButtons {
  init() {
    this.buttonGroups = document.querySelectorAll('.has-equal-buttons');

    if (!this.buttonGroups.length) {
      return;
    }

    this.equalElements = ['.is-equal', '.wp-block-button'];

    this.buttonClasses = ['c-btn', 'wp-block-button__link'];

    this.classes = {
      isSetEqual: 'is-set-equal',
    };

    this.minButtonWidth = 145;

    this.makeEqual();

    let debounce = null;
    window.addEventListener('resize', () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        this.makeEqual();
      }, 500);
    });
  }

  makeEqual() {
    this.buttonGroups.forEach((group) => {
      const minWidth =
        Number(group.dataset.equalButtonsMinWidth) || this.minButtonWidth;
      const buttons = group.querySelectorAll(this.equalElements);

      if (buttons.length > 1) {
        const widths = Array.from(buttons).map((button) => {
          return button.offsetWidth + 1;
        });
        const maxWidth = Math.max(...widths, minWidth);

        buttons.forEach((btn) => {
          const button = btn;

          if (!button.classList.contains(this.classes.isSetEqual)) {
            button.style.maxWidth = `${maxWidth}px`;
            button.style.width = `100%`;
            button.classList.add(this.classes.isSetEqual);
          }

          const hasButtonClass = this.buttonClasses.some((cls) =>
            button.classList.contains(cls),
          );

          if (hasButtonClass) {
            button.style.opacity = 1;
          } else {
            this.buttonClasses.forEach((cls) => {
              const btnElem = button.querySelector(`.${cls}`);

              if (btnElem) {
                btnElem.style.opacity = 1;
              }
            });
          }
        });
      } else if (buttons.length) {
        buttons.forEach((btn) => {
          btn.classList.add(this.classes.isSetEqual);
        });
      }
    });
  }

  reset() {
    const buttons = document.querySelectorAll(this.equalElements);

    if (buttons.length > 1) {
      buttons.forEach((btn) => {
        const button = btn;

        if (!button.closest('.has-equal-buttons')) {
          button.style.maxWidth = '';
          button.style.width = '';
          button.classList.remove(this.classes.isSetEqual);
        }
      });
    }
  }
}

export default new EqualButtons();
